
import React from "react";
import { Outlet } from "react-router-dom";
import classNames from "classnames";
import TopBar from "../dashboard/TopBar";
import Sidebar from "../dashboard/Sidebar";
import { SidebarProvider, useSidebarContext } from "../../contexts/SidebarContext";

const DashboardLayout = () => {
  return (
    <SidebarProvider>
      <TopBar />
      <div className="flex items-start pt-16">
        <Sidebar />
        <MainContent>
          <Outlet />
        </MainContent>
      </div>
    </SidebarProvider>
  );
}

const MainContent = () => {
  const { isOpenOnSmallScreens: isSidebarOpen } = useSidebarContext();

  return (
    <main
      className={classNames(
        'relative w-full h-full bg-gray-50 dark:bg-gray-900',
        isSidebarOpen ? 'lg:ml-16' : 'lg:ml-64'
      )}
    >
      <Outlet />
    </main>
  )
}

export default React.memo(DashboardLayout);
